import React from "react";
import "./css/SearchSuggestions.css";
import { ROOT_API_PATH } from "./actions/constant";

function SearchSuggestions(props) {
  let list = [];
  if (props.result && props.result.length === 0) {
    return (
      <div className="search-result" style={{ display: props.showList ? "block" : "none" }}>
        <ul>
          <li className="no-result-found">No activity or tour found.</li>
        </ul>
      </div>
    );
  }
  if (props.result) {
    let currentCategory = "";
    props.result.forEach(function(element) {
      let category = element.category;
      if (currentCategory !== element.category) {
        if (element.count > 1) {
          if (element.category === "Location") category = "locations";
          else if (element.category === "Activity") category = "activities";
        }
        list.push(
          <li key={element.category} className="result-count">
            {element.count + " " + category.toLowerCase()} found
          </li>
        );
        currentCategory = element.category;
      }
      list.push(
        <li key={element.url}>
          <a href={ROOT_API_PATH + element.url} target="_blank">
            {element.label}
          </a>
        </li>
      );
    });
  }

  return (
    <div className="search-result" style={{ display: props.showList ? "block" : "none" }}>
      <ul>{list}</ul>
    </div>
  );
}

export default SearchSuggestions;



// WEBPACK FOOTER //
// ./src/SearchSuggestions.jsx